import Column16 from '@carbon/icons-react/es/column/16';
import Row16 from '@carbon/icons-react/es/row/16';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { IconWrapper } from 'components/atoms/icon-shell/icon-shell';
import { toastService } from 'components/molecules/toast';
import { useTranslation } from 'hooks/use-translation';
import { GroupBy } from '../filter-menu-sidebar';
import { GroupByFilter, Item, NONE } from './group-by';

interface TaskBoardGroupByProps {
  groupBy: GroupBy;
  setGroupBy: (value: GroupBy, replace?: boolean) => void;
  rowFields: Item[];
  columnFields: Item[];
}

export const TaskBoardGroupBy: FC<TaskBoardGroupByProps> = ({
  groupBy,
  setGroupBy,
  rowFields,
  columnFields,
}) => {
  const titleText = useTranslation('kanban.group_by.same.title');
  const messageText = useTranslation('kanban.group_by.same.message');

  return (
    <>
      <GroupByFilter
        icon={
          <IconWrapper>
            <Row16 />
          </IconWrapper>
        }
        selected={groupBy.rowGroup || NONE}
        items={rowFields}
        onChange={(latest) => {
          if (groupBy.columnGroup === latest) {
            toastService({
              title: titleText,
              message: messageText,
            }).info();
          }
          const value = {
            ...groupBy,
            rowGroup:
              latest === NONE || groupBy.columnGroup === latest ? null : latest,
          };

          setGroupBy(value);
        }}
        label={<FormattedMessage id="rows" />}
      />
      <GroupByFilter
        icon={
          <IconWrapper>
            <Column16 />
          </IconWrapper>
        }
        selected={groupBy.columnGroup}
        items={columnFields}
        onChange={(latest) => {
          if (groupBy.rowGroup === latest) {
            toastService({
              title: titleText,
              message: messageText,
            }).info();
          }
          const value = {
            rowGroup: latest === groupBy.rowGroup ? null : groupBy.rowGroup,
            columnGroup: latest,
          };

          setGroupBy(value);
        }}
        label={<FormattedMessage id="col" />}
      />
    </>
  );
};
